'use client';

import { StandardLayoutEntries } from '@/lib/parsers/entries/customEntryTypes';
import { useView } from '@/lib/store/hooks';
import { useTranslations } from 'next-intl';
import { BlockContainer } from '../Blocks';
import Grid from '../ui/Grid';
import RelevantArea from './RelevantArea';
import RelevantAreaTitle from './RelevantAreaTitle';

export default function RelevantAreas() {
  const page = useView() as StandardLayoutEntries;
  const t = useTranslations('area');

  const services = page.serviceMultiple || [];
  const sectors = page.sectorMultiple || [];
  const products = page.productMultiple || [];

  return (
    (!!services.length || !!sectors.length) && (
      <BlockContainer paddingY colorSet="secondary" paper {...{ disableTransition: true }}>
        <Grid cx={{ rowGap: '3xl', columnGap: { lg: '3xl' } }}>
          {!!sectors.length && (
            <Grid.Col md={4} lg={3}>
              <RelevantAreaTitle title={t('relatedSectors')} />
              <RelevantArea entries={sectors} />
            </Grid.Col>
          )}
          {!!services.length && (
            <Grid.Col md={4} lg={3}>
              <RelevantAreaTitle title={t('relatedServices')} />
              <RelevantArea entries={services} />
            </Grid.Col>
          )}
          {!!products.length && (
            <Grid.Col md={4} lg={3}>
              <RelevantAreaTitle title={t('relatedProducts')} />
              <RelevantArea entries={products} />
            </Grid.Col>
          )}
        </Grid>
      </BlockContainer>
    )
  );
}
